<!-- Announcer.svelte-->
<script>
    import { router } from 'tinro';

    let current;

    $: {
        current = $router.path === '/' ? 'Home' : $router.path.slice(1);
        // window.scrollTo(0, 0);
        let elem = document.getElementById('databases-app');
        let position = elem.getBoundingClientRect().top + window.pageYOffset - 104; // 2em is approximately 32px for a font-size of 16px
        window.scrollTo({top: position, behavior: 'smooth'});
    }
</script>

<div class="sr-only" aria-live="assertive" aria-atomic="true">
    {#key current}
        Navigated to {current}
    {/key}
</div>

<style>
</style>